import { Grid, Typography } from '@mui/material';

import { BusinessSignup } from '@barboxx/models';

interface Props extends BusinessSignup.WithNotesCount {
    onItemClick: (id: number) => void;
}

export default function SignupCard({
    id,
    phone,
    firstName,
    lastName,
    businessName,
    notesCount,
    onItemClick,
}: Props) {
    const handleClick = () => onItemClick(id);

    return (
        <Grid
            container
            onClick={handleClick}
            justifyContent="center"
            padding={2}
            sx={theme => ({
                borderBottom: `solid 1px ${theme.palette.divider}`,
                cursor: 'pointer',
                '&:last-child': {
                    borderBottom: 0,
                },
            })}
        >
            <Typography variant="h4" mb={1}>
                {businessName}
            </Typography>
            <Grid container alignItems="center" gap={1}>
                <Typography variant="subtitle1">Contact: </Typography>
                <Typography variant="subtitle2">{`${firstName} ${lastName}`}</Typography>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid container alignItems="center" flex={1} gap={1}>
                    <Typography variant="subtitle1">Phone:</Typography>
                    <Typography variant="subtitle2">{phone}</Typography>
                </Grid>
                <Grid>Notes: {notesCount}</Grid>
            </Grid>
        </Grid>
    );
}
